export default{
    getReportsAgreementIndex: state =>{
        return state.reportAgreement.index
    },
    getReportsAgreementTitle: state =>{
        return state.reportAgreement.title
    },
    getReportsAgreementAgreed: state =>{
        return state.reportAgreement.agreed
    },
    getReportsAgreementContent: state =>{
        return state.reportAgreement.content
    },
    
}